"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekdayUtil = void 0;
const errors_1 = require("../../errors");
const Weekdays_1 = require("../models/Weekdays");
class WeekdayUtil {
    weekdayToDay(weekday) {
        if (weekday > 6 || weekday < 0) {
            throw new errors_1.OperationError(errors_1.OperationErrorCode.InvalidValue, `Day value must be between 0 and 6`);
        }
        if (weekday == Weekdays_1.Weekdays.Sunday)
            return 0;
        return weekday + 1;
    }
    dayToWeekday(day) {
        if (day > 6 || day < 0) {
            throw new errors_1.OperationError(errors_1.OperationErrorCode.InvalidValue, `Day value must be between 0 and 6`);
        }
        if (day == 0)
            return Weekdays_1.Weekdays.Sunday;
        return (day - 1);
    }
}
exports.WeekdayUtil = WeekdayUtil;
